import { css } from 'styled-components';
export const IconStyle = css `
    display: inline-flex;

    svg {
        display: inline-flex;
    }
`;
//# sourceMappingURL=Icon.styles.js.map